"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var getCurrentUrl = function getCurrentUrl() {
	return window.location.pathname + window.location.search;
};

exports.default = getCurrentUrl;


//////////////////
// WEBPACK FOOTER
// /data/wp-content/themes/gottwines/node_modules/swup/lib/helpers/getCurrentUrl.js
// module id = 63
// module chunks = 0